import { useMemo } from "react";
import { GetSpecialPackageProducts } from "../../features/client/clientInterface";

export const  useCustomizePackageItemModalUserMemo = ( packageProduct: GetSpecialPackageProducts[], selectedProducts: GetSpecialPackageProducts[] | null, selectedType: number ) => {
    
    const productTypes = useMemo(() => {
        const uniqueTypes = new Map<number, { id: number; name: string }>();

        uniqueTypes.set(0, {
            id: 0,
            name: "All Product",
        });

        packageProduct.forEach(product => {
            if (!uniqueTypes.has(product.type)) {
                uniqueTypes.set(product.type, {
                    id: product.type,
                    name: product.typeName,
                });
            }
        });

        return Array.from(uniqueTypes.values());
    }, [packageProduct]);

    const filteredProducts = useMemo(() => {
        if (selectedType === 0) return packageProduct;

        return packageProduct.filter(
            product => product.type === selectedType
        );
    }, [packageProduct, selectedType]);

    const selectedProductIds = useMemo(
        () => new Set(selectedProducts?.map(x => x.productID) ?? []),
        [selectedProducts]
    );

    return {
        productTypes,
        filteredProducts,
        selectedProductIds,
    };
}